<div class="progress-icon" *ngIf="progress == 100">
  <i class="fa fa-check"></i>
</div>

<div class="circle-wrap">
  <div class="circle">
    <div class="mask full" [style]="'transform: rotate(' + degrees + 'deg)'">
      <div class="fill" [style]="'transform: rotate(' + degrees + 'deg)'"></div>
    </div>
    <div class="mask half">
      <div class="fill" [style]="'transform: rotate(' + degrees + 'deg)'"></div>
    </div>
    <div class="inside-circle" *ngIf="badge">
      <img
        [src]="'/assets/images/gamification/badge-' + badge.name.toLowerCase() + '.svg'"
        [alt]="badge.name"
        style="vertical-align: middle"
        class="badge-image"
      />
      <div class="badge-name">{{ badge.name }} Badge</div>
      <div class="earn-label" pTooltip="Number of grabbed jobs">
        <span>{{ moves }} Jobs</span>
      </div>
    </div>

    <div class="inside-circle" *ngIf="!badge">
      <div class="no-badge-name">No Current Badge</div>
      <div class="earn-label" pTooltip="Number of grabbed jobs">
        <span>At {{ moves }} Jobs</span>
      </div>
    </div>
  </div>
</div>
